import * as modalActions from "../actions/certification.action";

const certification = (
  state = {
    updatedCertificateState: [],
    addedCertificate: [],
  },
  action,
) => {
  switch (action.type) {
    case modalActions.ADD_CERTIFICATION: {
      let selectedCertificate = action.data && action.data.filter((m) => m.selectedstatus === true);
      return Object.assign({}, state, {
        updatedCertificateState: action.data,
        addedCertificate: selectedCertificate,
      });
    }

    default:
      return state;
  }
};
export default certification;
